<template>
    <div class="container">
      <div class="class-list">
        <!-- 搜索 -->
        <div class="search-inner padding-right">
          <a-form layout="inline">
            <a-form-item class="name" label="学期">
              <a-select
                class="form-cell"
                placeholder="全部学期"
                v-model="queryParam.termId"
              >
                <a-select-option
                  v-for="(item, index) in termList"
                  :key="index"
                  :value="item.id"
                  >{{ item.termName }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item class="name" label="班级ID">
              <a-input-number
                class="form-cell"
                placeholder="请输入"
                type="number"
                v-model="queryParam.classId"
                @change="inputNumber(queryParam.classId)"
                :precision="0"
              ></a-input-number>
            </a-form-item>
  
            <a-form-item class="name" label="班级名称">
              <a-input
                class="form-cell"
                type="text"
                placeholder="请输入"
                v-model="queryParam.className"
              ></a-input>
            </a-form-item>
          </a-form>
        </div>
        <div class="search-inner padding-right">
          <a-form layout="inline">
            <a-form-item class="name" label="课程名称">
              <a-input
                class="form-cell"
                type="text"
                placeholder="请输入"
                v-model="queryParam.courseName"
              ></a-input>
            </a-form-item>
            <a-form-item class="name" label="课节名称">
              <a-input
                class="form-cell"
                type="text"
                placeholder="请输入"
                v-model="queryParam.lessonName"
              ></a-input>
            </a-form-item>
            <a-form-item class="name" label="学生家长">
              <a-input
                class="form-cell"
                type="text"
                placeholder="请输入"
                v-model="queryParam.parentName"
              ></a-input>
            </a-form-item>
          </a-form>
        </div>
        <div class="search-inner">
          <a-form layout="inline">
            <a-form-item class="name" label="评价分值">
              <a-select
                class="form-cell"
                placeholder="请选择"
                v-model="queryParam.score"
              >
                <a-select-option
                  v-for="(item, index) in classList"
                  :key="index"
                  :value="item"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item class="search-oper">
              <a-button class="search" type="primary" @click="searchStudent()"
                >查询</a-button
              >
              <a-button type="primary" @click="() => (queryParam = {})"
                >重置</a-button
              >
            </a-form-item>
          </a-form>
        </div>
        <!-- 表格数据 -->
        <a-table
          :columns="columns"
          :dataSource="studentList"
          disabled="true"
          :loading="loading"
          :pagination="pagination"
          :rowKey="getRowKey"
          @change="tableChange"
        >
          <span slot="gradeId" slot-scope="text, record">
            <template>
              <span>{{ record.gradeId | gradeScopeFilter }}</span>
            </template>
          </span>
          <span slot="gender" slot-scope="text, record">
            <template>
              <span>{{ record.gender | gender }}</span>
            </template>
          </span>
          <span slot="operate" slot-scope="text, record">
            <template>
              <div class="cut-off" @click="cutOff(record.id)">删除</div>
            </template>
          </span>
        </a-table>
      </div>
      <a-modal
        :closable="false"
        title="未查询到的学生或学号"
        :maskClosable="false"
        :width="400"
        :visible="barrenVisible"
        :confirmLoading="confirmLoading"
      >
        <template slot="footer">
          <a-button type="primary" key="back" @click="barrenVisible = false">
            确定
          </a-button>
        </template>
        <span v-for="(item, index) in barrenList" :key="index">{{ item }}</span>
      </a-modal>
    </div>
  </template>
  
  <script>
//   import student from '../../../api/student'
  
//   import classSet from '../../../api/classSet'
  
//   import sourceClass from '../../../api/sourceClass'
  import education from '../../api/education'

  import course from '../../api/course'

  import moment from 'moment'

  import Vue from 'vue'
  import { number } from 'echarts'
  import { isNumber } from 'lodash'
import { InputNumber } from 'ant-design-vue'
  
  const columns = [
    {
      title: '班级ID',
      dataIndex: 'classId',
      width: 60,
    },
    {
      title: '班级名称',
      dataIndex: 'className',
      width: 70,
    },
    {
      title: '课程名称',
      dataIndex: 'courseName',
      scopedSlots: { customRender: 'courseName' },
      width: 60,
    },
    {
      title: '课节名称',
      dataIndex: 'lessonName',
      width: 70,
    },
    {
      title: '上课老师',
      dataIndex: 'teacherName',
      width: 80,
    },
    {
      title: '上课时间',
      dataIndex: 'attendDate',
      scopedSlots: { customRender: 'attendDate' },
      width: 80,
    },
    {
      title: '家长',
      dataIndex: 'parentName',
      width: 80,
    },
    {
      title: '评价分数',
      dataIndex: 'score',
      width: 80,
    },
    {
      title: '评价内容',
      dataIndex: 'content',
      width: 130,
    },
    {
      title: '评价时间',
      dataIndex: 'gmtCreate',
      width: 100,
    },
  ]
  export default {
      name: "scheduleEvaluation",
      data() {
          return {
              moment,
              columns,
              visible: false,
              confirmLoading: false,
              studentList: [],
              selectedStudent: [],
              classId: "",
              pagination: {
              showTotal: (total) => `总共 ${total} 条`, // 显示总数
              current: 1,
              pageSize: 10,
              total: 0,
              pageSizeOptions: ['10', '20', '30', '50', '70', '100'],
              showLessItems: true,
              showSizeChanger: true,
              }, //分页数据对象
              loading: false,
              queryParam: {},
              classList: [1,2,3,4,5],
              itemList:[],
              termList:[],
              barrenVisible: false,
              barrenList: [],
              schoolId: Vue.ls.get('schoolId'),
          };
      },
            //初始化，显示
            created(id) {
            this.getTermList()
              console.log('进入了吗', this.schoolId)
              this.searchStudent();
          },
          // watch:{
          //   queryParam:{
          //     handler: function (newV,oldV){
          //     console.log(oldV,'2222',newV,'变化了吗')
          //   },
          //   deep:true
          //   } 
          // },
      methods: {
        getRowKey(record, index) {
          return index;
        },
          //table发生该表，分页，排序
          tableChange(pagination, filters, sorter) {
              //如果查询有地址的话，把地址解析之后带入
              let obj = this.queryParam;
              obj.currentPage = pagination.current;
              obj.pageSize = pagination.pageSize;
              this.pagination.current = pagination.current;
              this.pagination.pageSize = pagination.pageSize;
              //存在排序的时候
              if (sorter && sorter.columnKey) {
                  obj.sorter = `${sorter.columnKey}-${sorter.order == "ascend" ? "asc" : "desc"}`;
              }
              this.getClassList(obj);
          },
         async inputNumber(e){
            console.log(!isNaN(e) && typeof e !== 'number','e是啥')
            if(!isNaN(e) && typeof e !== 'number'){
              this.$nextTick(() => {
                this.queryParam.classId = ''
              },100)
            }
            console.log(this.queryParam.classId,'e是啥22')
          },
          //提交
          handleSubmit() {
              if (this.selectedStudent.length == 0) {
                  this.$message.warn("请选择学生");
                  return;
              }
              let req = {
                  classId: this.classId,
                  studentIds: this.selectedStudent.join(),
              };
          },
          //table选中事件
          onSelectChange(selectedRowKeys, value) {
              this.selectedStudent = [];
              value.map((item) => {
                  this.selectedStudent.push(item.id);
              });
          },
          // 获取学期选择框接口
          getTermList() {
            education.getClassTermList().then((res) => {
              this.termList = res.data
              console.log('获取学期列表--------', res)
            })
          },
          freshen(data){
            console.log(data,'子的数据传过来了吗235')
              this.searchStudent()
              // this.reload();
          },
          // 查询删除操作
          cutOff(data){
            console.log(data,'删除ID操作')
            student.deleteStudentList(
               data
        ).then((res) => {
              console.log('删除成功了吗')
              this.searchStudent();
            })
          },

          //隐藏
          handleCancel() {
              this.pagination.pageSize = 100;
              this.visible = false;
              this.$emit("closeForm");
          },
          //查询评价
          searchStudent() {
              setTimeout(()=>{
                this.getClassList(this.queryParam);
              },100)
              console.log(this.queryParam,'queryParam这个内容是啥')
          },
         async searchOriginalClass(id){
              const result = await sourceClass.getOriginalClassList(
                {id:id}
              )
              this.classList = result.data.list
                console.log(result,'原始班级是啥',this.classList,'classList是啥玩意')
          },
          //获取班级列表
          getClassList(req = {}) {
              this.loading = true;
              console.log("req123", req);
              console.log("判断了是什么",  isNaN(Number(req.studentNumber)));
              if(req.studentNumber){
                if( !isNaN(Number(req.studentNumber))){
                  req.studentNumber = Number(req.studentNumber);
                } else{
                  req.studentNumber = req.studentNumber;
                }
              }
              console.log(req,'reqreqreqrq')
              course
                  .LessonEvaluation({
                  ...req,
              })
                  .then((res) => {
                  console.log("res", res);
                  if (res.data.noSearchStudentNameOrNumber) {
                      this.barrenVisible = true;
                      this.barrenList = res.data.noSearchStudentNameOrNumber;
                  }
                  this.studentList = res.data.list;
                  this.loading = false;
                  this.pagination.current = res.data.pagination.current;
                  this.pagination.pageSize = res.data.pagination.pageSize;
                  this.pagination.total = res.data.pagination.total;
              });
          },
      },
  }
  </script>
  <style lang="scss" scoped>
  @import 'src/config/var';
  .container{
    background: white;
    margin: 20px;
    box-sizing: border-box;
    padding: 20px;
  }
  .class-list {
    overflow-y: auto;
    overflow-x: hidden;
    .oper {
      text-align: right;
      margin-bottom: 10px;
      > .export {
        margin-left: 10px;
      }
    }
  }
  .class-cell {
    font-size: 14px;
    color: $normal-color-dark;
    line-height: 26px;
  }
  .tab-active {
    color: $primary-color;
  }
  .tab-list {
    border-bottom: 1px solid $border-color;
    padding: 0px 0px 10px;
    margin-bottom: 20px;
    > .tab {
      display: inline-block;
      margin-right: 30px;
      font-size: 16px;
    }
  }
  .search-inner {
    margin-bottom: 10px;
  }

  .padding-right ::v-deep .ant-form-inline {
    padding-right: 15%;
    box-sizing: border-box;
  }

  .search-oper {
    .search {
      margin-right: 10px;
    }
  }
  
  
  .search-inner ::v-deep .ant-form-item-control {
    width: 220px;
  }
  
  .search-inner ::v-deep .ant-form-item-children {
    width: 220px;
  }
  
  .search-inner ::v-deep .ant-input{
    width: 220px;
  }
  
  .search-inner ::v-deep .form-cell{
    width: 220px;
  }
  
  // .search-inner ::v-deep .ant-form-inline{
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  // }

  .search-inner ::v-deep .ant-input-number-handler-wrap{
    display: none;
  }

  .search-inner .ant-btn-primary{
    background: #1890ff;
    color: #FFF;
    border-color: #bfbfbf;
  }

  .class-list ::v-deep .ant-table-header-column{
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }
  
  .class-list ::v-deep .ant-table-row-cell-break-word{
    vertical-align: middle;
    text-align: center;
  }
  
  .cut-off{
    color: RGB(73 149 274);
  }
  </style>
  